var _style, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLandDelivery(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "animated",
    id: "freepik_stories-in-no-time",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", null, "svg#freepik_stories-in-no-time:not(.animated) .animable {opacity: 0;}svg#freepik_stories-in-no-time.animated #freepik--background-simple--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown,6s Infinite  linear floating;animation-delay: 0s,1s;}svg#freepik_stories-in-no-time.animated #freepik--Window--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) zoomOut;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--Picture--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--Plant--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideDown;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--Character--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--shopping-cart--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) lightSpeedRight,6s Infinite  linear wind;animation-delay: 0s,1s;}svg#freepik_stories-in-no-time.animated #freepik--Box--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) fadeIn;animation-delay: 0s;}svg#freepik_stories-in-no-time.animated #freepik--Device--inject-14 {animation: 1s 1 forwards cubic-bezier(.36,-0.01,.5,1.38) slideUp;animation-delay: 0s;}            @keyframes slideDown {                0% {                    opacity: 0;                    transform: translateY(-30px);                }                100% {                    opacity: 1;                    transform: translateY(0);                }            }                    @keyframes floating {                0% {                    opacity: 1;                    transform: translateY(0px);                }                50% {                    transform: translateY(-10px);                }                100% {                    opacity: 1;                    transform: translateY(0px);                }            }                    @keyframes zoomOut {                0% {                    opacity: 0;                    transform: scale(1.5);                }                100% {                    opacity: 1;                    transform: scale(1);                }            }                    @keyframes slideUp {                0% {                    opacity: 0;                    transform: translateY(30px);                }                100% {                    opacity: 1;                    transform: inherit;                }            }                    @keyframes lightSpeedRight {              from {                transform: translate3d(50%, 0, 0) skewX(-20deg);                opacity: 0;              }              60% {                transform: skewX(10deg);                opacity: 1;              }              80% {                transform: skewX(-2deg);              }              to {                opacity: 1;                transform: translate3d(0, 0, 0);              }            }                    @keyframes wind {                0% {                    transform: rotate( 0deg );                }                25% {                    transform: rotate( 1deg );                }                75% {                    transform: rotate( -1deg );                }            }                    @keyframes fadeIn {                0% {                    opacity: 0;                }                100% {                    opacity: 1;                }            }        ")), /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-simple--inject-14",
    className: "animable",
    style: {
      transformOrigin: "249.42px 248.942px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,421H432.7c3.16-3.58,6.89-9.51,7.81-10.74A189.79,189.79,0,0,0,463.29,370c24.28-58.18,20-125.82-5.49-183-18.9-42.32-51.94-78.85-98.41-97.06-42.87-16.81-102-21.17-138.41,10s-30.43,86.21-67,117.37c-1,.87-2.07,1.71-3.14,2.52-19.92,14.94-47.32,14.62-71,20.76-24.57,6.38-47.12,22.33-55.65,45-11.27,30-1.08,64.34,16.34,90.54C61.78,408.08,94.19,417.2,130,421Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "249.42px 248.942px"
    },
    id: "eldvttv4lqtdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elkfyz3qwzyeh"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M130,421H432.7c3.16-3.58,6.89-9.51,7.81-10.74A189.79,189.79,0,0,0,463.29,370c24.28-58.18,20-125.82-5.49-183-18.9-42.32-51.94-78.85-98.41-97.06-42.87-16.81-102-21.17-138.41,10s-30.43,86.21-67,117.37c-1,.87-2.07,1.71-3.14,2.52-19.92,14.94-47.32,14.62-71,20.76-24.57,6.38-47.12,22.33-55.65,45-11.27,30-1.08,64.34,16.34,90.54C61.78,408.08,94.19,417.2,130,421Z",
    style: {
      fill: "rgb(255, 255, 255)",
      opacity: 0.7,
      transformOrigin: "249.42px 248.942px"
    },
    className: "animable",
    id: "elfx0t2h3cv9i"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Window--inject-14",
    className: "animable",
    style: {
      transformOrigin: "339.855px 192.33px"
    }
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 79 220.69 79 219.16 94.93 336.59 94.93 336.59 79",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 86.965px"
    },
    id: "elza9p724yge",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 94.93 220.69 94.93 219.16 110.87 336.59 110.87 336.59 94.93",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 102.9px"
    },
    id: "el842osqcrs3l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 110.87 220.69 110.87 219.16 126.8 336.59 126.8 336.59 110.87",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 118.835px"
    },
    id: "elbx5n88zb5ai",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 126.8 220.69 126.8 219.16 142.73 336.59 142.73 336.59 126.8",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 134.765px"
    },
    id: "elnxmat4usa5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 142.73 220.69 142.73 219.16 158.67 336.59 158.67 336.59 142.73",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 150.7px"
    },
    id: "elsg3r7btw0k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 158.67 220.69 158.67 219.16 174.6 336.59 174.6 336.59 158.67",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 166.635px"
    },
    id: "elspf1wt14a08",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 174.6 220.69 174.6 219.16 190.53 336.59 190.53 336.59 174.6",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 182.565px"
    },
    id: "elybcpxuufw7h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 190.53 220.69 190.53 219.16 206.47 336.59 206.47 336.59 190.53",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 198.5px"
    },
    id: "el8p5zron42iq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 206.47 220.69 206.47 219.16 222.4 336.59 222.4 336.59 206.47",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 214.435px"
    },
    id: "elppus1q38f9p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 222.4 220.69 222.4 219.16 238.33 336.59 238.33 336.59 222.4",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 230.365px"
    },
    id: "eluw4ow8gameg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 238.33 220.69 238.33 219.16 254.27 336.59 254.27 336.59 238.33",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 246.3px"
    },
    id: "elgr8tefh4z1",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 254.27 220.69 254.27 219.16 270.2 336.59 270.2 336.59 254.27",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 262.235px"
    },
    id: "elerwiga58nav",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 270.2 220.69 270.2 219.16 286.13 336.59 286.13 336.59 270.2",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 278.165px"
    },
    id: "el6frm0r8bov",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 286.13 220.69 286.13 219.16 302.07 336.59 302.07 336.59 286.13",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 294.1px"
    },
    id: "elbigb8foahs6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.59 302.07 220.69 302.07 219.16 318 336.59 318 336.59 302.07",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "277.875px 310.035px"
    },
    id: "el5ju6s4ar02l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 79 339.83 79 338.3 94.93 455.72 94.93 455.72 79",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 86.965px"
    },
    id: "ela72dsscczn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 94.93 339.83 94.93 338.3 110.87 455.72 110.87 455.72 94.93",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 102.9px"
    },
    id: "eljjiqxo3dtf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 110.87 339.83 110.87 338.3 126.8 455.72 126.8 455.72 110.87",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 118.835px"
    },
    id: "elv6f5armkos",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 126.8 339.83 126.8 338.3 142.73 455.72 142.73 455.72 126.8",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 134.765px"
    },
    id: "elgx3pkvpmmc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 142.73 339.83 142.73 338.3 158.67 455.72 158.67 455.72 142.73",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 150.7px"
    },
    id: "el7kj09vtl1cw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 158.67 339.83 158.67 338.3 174.6 455.72 174.6 455.72 158.67",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 166.635px"
    },
    id: "els8xj6jmombk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 174.6 339.83 174.6 338.3 190.53 455.72 190.53 455.72 174.6",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 182.565px"
    },
    id: "el09t9ca12aqdc",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 190.53 339.83 190.53 338.3 206.47 455.72 206.47 455.72 190.53",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 198.5px"
    },
    id: "el5pksvi7uegk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 206.47 339.83 206.47 338.3 222.4 455.72 222.4 455.72 206.47",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 214.435px"
    },
    id: "ellkpi9vp1kh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 222.4 339.83 222.4 338.3 238.33 455.72 238.33 455.72 222.4",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 230.365px"
    },
    id: "el5ucv05kie5v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 238.33 339.83 238.33 338.3 254.27 455.72 254.27 455.72 238.33",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 246.3px"
    },
    id: "elj893j282j8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 254.27 339.83 254.27 338.3 270.2 455.72 270.2 455.72 254.27",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 262.235px"
    },
    id: "eltff4h04ppcb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 270.2 339.83 270.2 338.3 286.13 455.72 286.13 455.72 270.2",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 278.165px"
    },
    id: "eloo0yuhdugx",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 286.13 339.83 286.13 338.3 302.07 455.72 302.07 455.72 286.13",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 294.1px"
    },
    id: "eldagfzz8jfgl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "455.72 302.07 339.83 302.07 338.3 318 455.72 318 455.72 302.07",
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "397.01px 310.035px"
    },
    id: "elm90acd4ymws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 216.45,
    y: 66.66,
    width: 245.08,
    height: 12.02,
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "338.99px 72.67px"
    },
    id: "elhfof1hqpq1r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 461.53,
    y1: 78.68,
    x2: 461.53,
    y2: 290.37,
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "461.53px 184.525px"
    },
    id: "el2yk7ya9mqu4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 458.86,
    y1: 79.02,
    x2: 458.86,
    y2: 224.26,
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "458.86px 151.64px"
    },
    id: "eltlblrc16xal",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 459.97,
    y: 289.9,
    width: 3.29,
    height: 5.39,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "461.615px 292.595px"
    },
    id: "el7iel1q557",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457,
    y: 223.1,
    width: 3.3,
    height: 5.39,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "458.65px 225.795px"
    },
    id: "el4khlldpu7bs",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Picture--inject-14",
    className: "animable",
    style: {
      transformOrigin: "111px 167.5px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 48,
    y: 89,
    width: 126,
    height: 157,
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "111px 167.5px"
    },
    id: "elycasb5y3o7b",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.21,
    y: 93,
    width: 119.58,
    height: 149,
    style: {
      fill: "none",
      stroke: "rgb(163, 163, 163)",
      strokeMiterlimit: 10,
      transformOrigin: "111px 167.5px"
    },
    id: "eln3fa05tc81",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 89,
    y: 140.09,
    width: 44,
    height: 54.83,
    style: {
      fill: "rgb(214, 214, 214)",
      transformOrigin: "111px 167.505px"
    },
    id: "elnjfei3fy11",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Plant--inject-14",
    className: "animable",
    style: {
      transformOrigin: "151.026px 361.315px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M152,397s.45-16.09-.12-29.93.58-43.52.58-43.52",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "152.091px 360.275px"
    },
    id: "el76pnel1huhj",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.19,
    y1: 341.02,
    x2: 145.9,
    y2: 336.08,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "149.045px 338.55px"
    },
    id: "el8jpuxke5no5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.13,
    y1: 344.43,
    x2: 154.36,
    y2: 340.81,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "153.245px 342.62px"
    },
    id: "el6543fq2dzep",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.61,
    y1: 358.74,
    x2: 157.2,
    y2: 354.13,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "154.405px 356.435px"
    },
    id: "elf6ngr4z91l",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 152.46,
    y1: 329.65,
    x2: 149.51,
    y2: 326.97,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "150.985px 328.31px"
    },
    id: "el9wg0nit68zw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.56,
    y1: 361.26,
    x2: 147.87,
    y2: 357.3,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "149.715px 359.28px"
    },
    id: "elnznv61t5v9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 151.89,
    y1: 376.79,
    x2: 144.21,
    y2: 369.79,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "148.05px 373.29px"
    },
    id: "eln7incw8yupg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.08,385.42a44.81,44.81,0,0,0,5.7-2.65",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "154.93px 384.095px"
    },
    id: "elf6tol4e3c6h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M147.85,343.51c-3.09-2.39-13.43-2-15.43,3s4.31,13,10.41,12.45c2.38-.22,3.41-.39,4.34-1.72h0l-8.5-8.31,9.2,7.39a7.21,7.21,0,0,0,.63-1.51c.11-.37.2-.76.29-1.18C149.38,350.66,150.73,345.74,147.85,343.51Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "140.834px 350.539px"
    },
    id: "el4h043zgkf7e",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.85,337.77a1.36,1.36,0,0,1,0,.17c-.83,3.69-5.05,5.78-8.6,5.47a8.75,8.75,0,0,1-1.46-.27,10.17,10.17,0,0,0-.91,8.95,5.38,5.38,0,0,0,.6,1.17c1-.85,12.23-10.4,12.23-10.4l-11.61,11.19c3.49,3.75,11.71,3.24,14.57-3.71S171.88,338.76,167.85,337.77Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "164.965px 347.068px"
    },
    id: "elsmhpn5tutmo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M162.16,324.86c-6-1.33-11.41,1.41-11.31,7.69a10.16,10.16,0,0,0,3.35,7.37l6.14-8.52-5.22,9.23a9,9,0,0,0,1.56.84,8.12,8.12,0,0,0,2.39.57c3.54.31,7.76-1.78,8.6-5.47C168.6,332.44,168.18,326.18,162.16,324.86Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "159.448px 333.301px"
    },
    id: "el329bbi3f3qz",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.13,303a47.8,47.8,0,0,0-4.47,2.07c-3.85,1.88-6.89,8-3.85,13.19a9.09,9.09,0,0,0,5.15,4.51l1.54-15L152.88,323a4,4,0,0,0,.88,0c2.5-.26,6.46-3.25,6.84-9.39S155.13,303,155.13,303Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "153.094px 313.012px"
    },
    id: "els73dt54f96d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.54,316.62l11.62,9.29a3.23,3.23,0,0,0,.11-1.31c-.53-5.32-5.84-8.4-9.35-9.51s-5.93.87-3.68,6,8.17,7.52,10.81,6.78a3,3,0,0,0,1.6-1Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "142.331px 321.397px"
    },
    id: "el0ezphlj3ajvp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.54,328.53c-2.51.08-6.57-1.71-8.94-5.16a4.75,4.75,0,0,0-5.12,4.16c-1.18,5.55,2.83,11.35,8.61,10.64a7.67,7.67,0,0,0,4.82-2.05l-10.34-9.43,11.06,8.43a3.43,3.43,0,0,0,.41-1.28A9.24,9.24,0,0,0,145.54,328.53Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "138.748px 330.791px"
    },
    id: "eliwug2jy26h",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.48,359.35a8.87,8.87,0,0,1-3,.71c-3.78.35-7.63-2.61-9.55-6.09-2.32.38-4.17,1.62-4.62,4.16-1.14,6.49,4.86,15,10.93,13.69a8.69,8.69,0,0,0,4.22-2.15l-13.25-12.74,14,11.88a7.41,7.41,0,0,0,1.5-3.54A8.14,8.14,0,0,0,145.48,359.35Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "137.164px 362.962px"
    },
    id: "el0jjyae67kb2q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M172.13,372.66c-4.45-5.15-9.76-.54-9.76-.54s-3.25,1.08-4.47,5.68a7,7,0,0,0,.16,4.25l13.4-7.81-13.08,8.54c1.22,2.31,3.88,3.73,7.53,2.7C171.81,383.83,176.59,377.82,172.13,372.66Z",
    style: {
      fill: "#3293C4",
      transformOrigin: "165.763px 378.022px"
    },
    id: "els2nkr5vunil",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 142.48,
    y: 392.16,
    width: 18.55,
    height: 27.47,
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "151.755px 405.895px"
    },
    id: "eldpwoadu00lm",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Character--inject-14",
    className: "animable",
    style: {
      transformOrigin: "327.362px 309.215px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M305.59,312.18l-.72-5.56c-.78-5.3-2.8-19.18-2.8-20.52,0-1.65-7.66-6.41-7.66-6.41l-9.22,13.12-6.33,12.35s4.07,3.69,7.68,6.4a21.47,21.47,0,0,0,7.87,3.52l18.45,63.28,12.41-25.08Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "302.065px 329.025px"
    },
    id: "ellblzvla4azn",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "el7dk5j0iden"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 271.68,
    y: 260.62,
    width: 23.2,
    height: 45.8,
    rx: 4.96,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.28px 283.52px",
      transform: "rotate(-2.82deg)"
    },
    className: "animable",
    id: "eltrojr0ajby8"
  })), /*#__PURE__*/React.createElement("g", {
    id: "elznj2n8u1kw"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 273.13,
    y: 260.51,
    width: 23.2,
    height: 45.8,
    rx: 4.96,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "284.73px 283.41px",
      transform: "rotate(-2.82deg)"
    },
    className: "animable",
    id: "elmtljr5y0tfp"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M294.75,266.48a5,5,0,0,0-4.09-4.64L289.07,264l-9.1.57-2.84-1.9,12.49-.86h-.07l-11.74.58a5,5,0,0,0-4.71,5.2l1.62,32.82a5,5,0,0,0,5.2,4.71l11.73-.58a5,5,0,0,0,4.71-5.2Z",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "284.73px 283.467px"
    },
    id: "el48el567vjk5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M301.16,313.3a8,8,0,0,1-6.93-6.93c-.91-6.33,2.11-13.56,2.11-13.56a41.76,41.76,0,0,0-6.33-3c-3.32-1.21-.91-7.54.3-5.73s9.64,3,12.05,4.52,3,10.25,3,10.25l.21,13.34",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "296.948px 298.528px"
    },
    id: "elmrl99qppjm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.76,421,419,341.76a13.07,13.07,0,0,0-7.09-16.69h0a13.08,13.08,0,0,0-17.1,6.8L355.94,421Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "387.9px 372.514px"
    },
    id: "elrk7c11wjfd7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.67,385c-1.18.89-25.11,29.48-30.56,36H352c4.21-5.85,21.11-29.81,28.37-46.67,8.34-19.33,9-42.33,7.34-49.33s-3.34-12-3.34-12S352,318.67,335,327.67c0,0-20.67,16-24.67,26.33S314,384,312.67,385Z",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "335.276px 367px"
    },
    id: "elgudcyt6tv3",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.92,373.39c.77-2,1.49-4,2.15-6,3.09-9.44,7-20.82,4.93-30.82-2-9.67-14.33-8.67-21.33-3.34s-12,18-15,29-15.73,36.12-15.73,36.12-45.67-9.67-51-11.67-12.67-5.33-17.67-10-18.33-11.67-23-17-5.33-3.67-5-1.67,2.67,4.34,4.33,6.34a66.06,66.06,0,0,0,5,5s-7.66-1.67-11.33-3-5.33-3.34-6.33-1.67,0,3.67,3.33,5.33,16.33,5.34,16.33,5.34H226.27c-2.67,0-6.33,1.66-4.67,3.33s10,.67,12.34.67h7s-9.34,3.33-12,3.66-2.34,3-.34,3.34,16.34-2.67,16.34-2.67,6,4.67,8.66,5.33a39.48,39.48,0,0,0,7.34.67s24,16,42,22.33c12.37,4.36,35.45,16.41,45.27,2.51C355.18,404.64,365.6,384.59,369.92,373.39Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "298.575px 375.131px"
    },
    id: "elota14ttcmho",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M361.35,230.22s-7.14,9.28-7.86,14.28.36,7.85-2.14,9.28-10,1.42-11.06,5,3.92,10,3.92,10,.72,16.06,2.15,19.62,14.27,4.29,14.27,4.29L358.49,308l21.06-6.42,5.71-20.7s8.21-3.57,11.06-15-2.14-23.2-14.63-30.69S361.35,230.22,361.35,230.22Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "368.621px 268.906px"
    },
    id: "elwpothyitzr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "360.63 292.68 371.34 293.79 359.91 299.82 360.63 292.68",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "365.625px 296.25px"
    },
    id: "elr2dx0a42zu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.57,270.91s6.78,1.07,10.35-3.57",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "354.745px 269.178px"
    },
    id: "elflcazff3csb",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.9,252.79c-.53,1.32-1.58,2.15-2.35,1.84s-1-1.63-.43-2.95,1.59-2.16,2.35-1.85S359.43,251.46,358.9,252.79Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "357.5px 252.23px"
    },
    id: "eltxzo84dspnr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.06,243s3.94-2.45,6.53,2.45",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "361.325px 243.919px"
    },
    id: "elbv332i20kfg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M351.93,271.15s-.13,5.57,1.91,5.44,4.49-7.49,4.49-7.49S356.83,270.87,351.93,271.15Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "355.129px 272.846px"
    },
    id: "eltlbyagv6l4r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.33,299s-26.66,10-34.66,12.67-16,19-16,19,39.66-13.34,47-15.34l5.66-.66S387,301,383.33,299Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "359.19px 314.835px"
    },
    id: "el6eo5ifz3mws",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.34,214.14s-.94.47,2.36-6.59-12.73-13.67-31.1-8-16,20.74-13.67,27.81,16,5.65,15.55,10.36-3.3,9.43,1.89,13.67.94,3.3,2.35,5.66,6.13.94,7.54,1.88,5.18,4.24.94,10.84-8.95,5.65-8,13.19,2.83,14.61,12.73,17.44,18.37,3.3,19.79-4.71-3.77-9.9,1.88-13.2,21.21-4.71,23.09-20.26S432.8,232.52,422,223.57A41.64,41.64,0,0,0,399.34,214.14Z",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "395.255px 249.841px"
    },
    id: "elxcqdrcy2do",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.65,291.92c2.41,4.29,7.28,6.15,10,5.15,4-1.52,4.54-9.09-.51-10.1s-6.56,2-4,4.54",
    style: {
      fill: "none",
      stroke: "rgb(156, 156, 156)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "397.219px 292.052px"
    },
    id: "elnxm54p2h0p",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.45,225.54c2.53,4,8.67,6.63,19.56,9.93,16.66,5.05,20.7,18.18,16.66,24.74s-16.16,13.13-18.18,23.22a13.77,13.77,0,0,0-.15,4.71",
    style: {
      fill: "none",
      stroke: "rgb(156, 156, 156)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "390.285px 256.84px"
    },
    id: "elm3dvt3b5f6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383.43,215.28s6.06-.51,3-5.56-14.64-1-16.15,8.08a13.48,13.48,0,0,0-.13,4.26",
    style: {
      fill: "none",
      stroke: "rgb(156, 156, 156)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "378.666px 214.791px"
    },
    id: "elbir34vtzoa",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.47,233.53c5.21,2.75,11.58,8.13,12.32,18.1,1,13.63-5.05,18.17-15.14,24.23S400.09,287,400.09,287",
    style: {
      fill: "none",
      stroke: "rgb(156, 156, 156)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "409.987px 260.265px"
    },
    id: "el29140mztrw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.61,230.93a25,25,0,0,1,4,1.28",
    style: {
      fill: "none",
      stroke: "rgb(156, 156, 156)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "403.61px 231.57px"
    },
    id: "elwbq5kw6tah",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--shopping-cart--inject-14",
    className: "animable animator-active",
    style: {
      transformOrigin: "282.105px 185.535px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M269.45,114.31a48.53,48.53,0,0,0-32.26,31.74",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "253.32px 130.18px"
    },
    id: "elg03esp89xd5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M293.48,113.36a48.38,48.38,0,0,0-10.14-1.07,49.29,49.29,0,0,0-6.81.48",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "285.005px 112.825px"
    },
    id: "elxwxocs7y4y",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M329.57,175.08a48.48,48.48,0,0,0-30.3-60.1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "315.505px 145.03px"
    },
    id: "elet1zyql8icp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M325.1,185.19a47.89,47.89,0,0,0,3.43-7.1",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "326.815px 181.64px"
    },
    id: "elibv45v3bjim",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M263.08,204.68a48.45,48.45,0,0,0,53.53-8.82",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "289.845px 202.485px"
    },
    id: "el3x6kk4721rw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M255.41,200.24a51,51,0,0,0,4.44,2.8",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "257.63px 201.64px"
    },
    id: "elppwqv5hp96d",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.55,153A48.41,48.41,0,0,0,252,197.59",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "243.467px 175.295px"
    },
    id: "elivk65zn0l5g",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.34,
    cy: 160.7,
    r: 43.8,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "283.34px 160.7px"
    },
    id: "elv7wznanybu",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M310.27,189.76H261.53a2.79,2.79,0,0,1-2.76-2.39l-8.66-56.44H239.27a2.78,2.78,0,0,1,0-5.56h13.25a2.78,2.78,0,0,1,2.75,2.39l8.67,56.44h46.33a2.78,2.78,0,1,1,0,5.56Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.77px 157.565px"
    },
    id: "elk5q5dsj0uhl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.47,
    y: 124.66,
    width: 11.23,
    height: 7.08,
    rx: 3.34,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "238.085px 128.2px"
    },
    id: "el6k3otfq4bp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.36 178.03 262.79 178.03 262.17 174.06 256.73 174.06 257.36 178.03",
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "259.76px 176.045px"
    },
    id: "elz425zc6h3xl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "309.29 175.31 256.15 175.31 251.46 138.75 313.98 138.75 309.29 175.31",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "282.72px 157.03px"
    },
    id: "elbrtmf14236v",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.41,171.33h0a2.66,2.66,0,0,1-2.66-2.66V150.24a2.67,2.67,0,0,1,2.66-2.67h0a2.67,2.67,0,0,1,2.66,2.67v18.43A2.66,2.66,0,0,1,269.41,171.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "269.41px 159.45px"
    },
    id: "eljvy6ydmt8pq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M278.83,171.33h0a2.66,2.66,0,0,1-2.66-2.66V150.24a2.67,2.67,0,0,1,2.66-2.67h0a2.67,2.67,0,0,1,2.66,2.67v18.43A2.66,2.66,0,0,1,278.83,171.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "278.83px 159.45px"
    },
    id: "elpbvdsir3y6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.25,171.33h0a2.66,2.66,0,0,1-2.66-2.66V150.24a2.67,2.67,0,0,1,2.66-2.67h0a2.67,2.67,0,0,1,2.66,2.67v18.43A2.66,2.66,0,0,1,288.25,171.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "288.25px 159.45px"
    },
    id: "elteynaovv0ud",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M297.67,171.33h0a2.66,2.66,0,0,1-2.66-2.66V150.24a2.67,2.67,0,0,1,2.66-2.67h0a2.67,2.67,0,0,1,2.66,2.67v18.43A2.66,2.66,0,0,1,297.67,171.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "297.67px 159.45px"
    },
    id: "el6h1jpcsljhq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.01,
    cy: 189.5,
    r: 6.55,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "273.01px 189.5px"
    },
    id: "elywsz42msexi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 273.01,
    cy: 189.5,
    r: 2.81,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "273.01px 189.5px"
    },
    id: "elf2ujufhs2x",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 295.18,
    cy: 189.5,
    r: 6.55,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.18px 189.5px"
    },
    id: "elyjp68b5txt",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M298,189.5a2.81,2.81,0,1,0-2.81,2.81A2.8,2.8,0,0,0,298,189.5Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "295.19px 189.5px"
    },
    id: "elzr3g9d44xaq",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 306.96,
    y1: 144.71,
    x2: 312.74,
    y2: 144.71,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "309.85px 144.71px"
    },
    id: "el7di4jkxylnm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 299.72,
    y1: 144.71,
    x2: 303.82,
    y2: 144.71,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "301.77px 144.71px"
    },
    id: "el7pqtzhbxfq7",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 252.94,
    y1: 144.71,
    x2: 296.58,
    y2: 144.71,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "274.76px 144.71px"
    },
    id: "elv6xi6zt79r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 283.34,
    y1: 204.5,
    x2: 283.34,
    y2: 255.99,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeMiterlimit: 10,
      transformOrigin: "283.34px 230.245px"
    },
    id: "elp5xyposogm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 283.34,
    cy: 255.99,
    r: 2.79,
    style: {
      fill: "rgb(38, 50, 56)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "283.34px 255.99px"
    },
    id: "elmssr57vbhk",
    className: "animable"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 314.67,
    cy: 142.23,
    r: 12.5,
    style: {
      fill: "#3293C4",
      transformOrigin: "314.67px 142.23px"
    },
    id: "elqymcx66vj4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M314.67,156.23a14,14,0,1,1,14-14A14,14,0,0,1,314.67,156.23Zm0-25a11,11,0,1,0,11,11A11,11,0,0,0,314.67,131.23Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "314.67px 142.23px"
    },
    id: "el7tfc01gllc8",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M315.49,146.79h-.11a1.48,1.48,0,0,1-1.18-.72L309.38,138a1.5,1.5,0,1,1,2.57-1.54l3.72,6.21L326,129.79a1.5,1.5,0,0,1,2.34,1.88l-11.68,14.56A1.53,1.53,0,0,1,315.49,146.79Z",
    style: {
      fill: "rgb(255, 255, 255)",
      transformOrigin: "318.897px 138.011px"
    },
    id: "elyamyegip71o",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Box--inject-14",
    className: "animable",
    style: {
      transformOrigin: "155.895px 273.057px"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M165,272.46s7.66-2.19,8.91-2.82,7.34-7.19,7.34-8.12-2.19-.47-3.9.46-7,6.72-7,6.72Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "173.125px 266.736px"
    },
    id: "elctd341yjybg",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.15,274.33s10.16-4.53,11.26-5.31,5.62-5.47,5.94-7-3.13-1.09-4.07-.62-6.56,6.09-7.19,6.72-7,5.94-7,5.94S157,275.11,160.15,274.33Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "167.891px 267.788px"
    },
    id: "elg2xcej6wq5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.43,276.73s10-10.4,11.89-11.52,24.15-1.11,24.15-1.11,10.77-3,12.63-3.35,1.49,3.35-1.11,4.84-10.41,8.54-13.38,10.4-21.92,4.46-21.92,4.46l-9.29,11.14-9.66-5.94Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "145.002px 276.158px"
    },
    id: "elgw60pj0bvdw",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.47,264.1s4.75-.55,4.28.85-2.19,4.38-5.47,4.54l-13.44.62",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "154.311px 267.052px"
    },
    id: "elc9olr40js4",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116.74,285.65s-8.41-.65-10.07.35S84,310.67,84,310.67l7.58,36.4c-.34,1.47,34.17-34.57,39.09-45.4,2.12-4.68-3-10.34-3-10.34Z",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "107.592px 316.278px"
    },
    id: "eldzep3t747g6",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "119.25 276.11 135.95 287.73 128.87 296.19 112.85 285.3 119.25 276.11",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.4px 286.15px"
    },
    id: "eld0ymkrlf7qm",
    className: "animable"
  }), /*#__PURE__*/React.createElement("g", {
    id: "elqse3kvn4wx"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 114,
    y: 219.5,
    width: 88,
    height: 43.5,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "158px 241.25px",
      transform: "rotate(-2.83deg)"
    },
    className: "animable",
    id: "elhmodc2fbc1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el55a5l4qdyki"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 115.86,
    y: 223.61,
    width: 17.15,
    height: 8.76,
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "124.435px 227.99px",
      transform: "rotate(-2.82deg)"
    },
    className: "animable",
    id: "elobpsclkw2b"
  })), /*#__PURE__*/React.createElement("g", {
    id: "el7m2rczd8x1p"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 183.96,
    y: 217.77,
    width: 18,
    height: 43.5,
    style: {
      fill: "rgb(219, 219, 219)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "192.96px 239.52px",
      transform: "rotate(-2.83deg)"
    },
    className: "animable",
    id: "elzjy7kpftga"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M200.87,217.36s7,4.85,9.78,9.83",
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "205.76px 222.275px"
    },
    id: "el24b3rjz8p04",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "208.16 223.87 207.89 234.65 216.18 244.6 227.79 234.38 219.5 224.15 208.16 223.87",
    style: {
      fill: "#3293C4",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "217.84px 234.235px"
    },
    id: "elc6d725uttyh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: 199,
    x2: 158,
    y2: 208.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "158px 203.75px"
    },
    id: "el1qjzwmg9126",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 158,
    y1: 282.5,
    x2: 158,
    y2: 292,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "158px 287.25px"
    },
    id: "elz0vhzg6u9fh",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 101.5,
    y1: 213.5,
    x2: 108,
    y2: 218.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "104.75px 216px"
    },
    id: "elzahbpl4dl9c",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 108.5,
    y1: 247,
    x2: 98,
    y2: 247.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "103.25px 247.25px"
    },
    id: "elm74h0xvnp9r",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 115,
    y1: 272,
    x2: 108.5,
    y2: 278.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "111.75px 275.25px"
    },
    id: "elnrob4j4yoqo",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 206.5,
    y1: 265,
    x2: 214.5,
    y2: 272.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "210.5px 268.75px"
    },
    id: "ellt6to5vm5de",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 204.5,
    y1: 213,
    x2: 211,
    y2: 205.5,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      transformOrigin: "207.75px 209.25px"
    },
    id: "els3bhgroz1qh",
    className: "animable"
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Device--inject-14",
    className: "animable",
    style: {
      transformOrigin: "243.09px 324.545px"
    }
  }, /*#__PURE__*/React.createElement("rect", {
    x: 130.69,
    y: 412.97,
    width: 99.54,
    height: 8.03,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "180.46px 416.985px"
    },
    id: "elw0x3ek30i5k",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.32,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "135.765px 411.56px"
    },
    id: "elsqp1mijb2yl",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 141.21,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "144.655px 411.56px"
    },
    id: "elkbdqfidbwr",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 150.11,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "153.555px 411.56px"
    },
    id: "elmihjiburt9",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 159,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "162.445px 411.56px"
    },
    id: "el432j7nbozaf",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 167.9,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "171.345px 411.56px"
    },
    id: "elqpw1f9wx4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 176.79,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "180.235px 411.56px"
    },
    id: "el7wzzihay8h5",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 185.69,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "189.135px 411.56px"
    },
    id: "elb0imygyby4q",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 194.58,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "198.025px 411.56px"
    },
    id: "el8moosozty4i",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 203.48,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "206.925px 411.56px"
    },
    id: "el65vfdy5re26",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 212.37,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "215.815px 411.56px"
    },
    id: "el5tjn5crpsct",
    className: "animable"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 221.27,
    y: 410.27,
    width: 6.89,
    height: 2.58,
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "224.715px 411.56px"
    },
    id: "el5kt2jzcwmta",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M109,421H65.57a9,9,0,0,1-8.82-10.64l19.4-102.47,4.73.9L61.48,411.25a4.15,4.15,0,0,0,4.09,4.93H109Z",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "82.7997px 364.445px"
    },
    id: "el0rbyrf23rnp",
    className: "animable"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.98 302.46 71.02 304.6 76.37 332.96 84.94 331.36 77.98 302.46",
    style: {
      fill: "rgb(38, 50, 56)",
      transformOrigin: "77.98px 317.71px"
    },
    id: "ely01e6dej4m",
    className: "animable"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94,391.44h0L61.66,228.09l2.48,1.54A23.54,23.54,0,0,1,74.81,245L99.75,371A23.51,23.51,0,0,1,94,391.44Z",
    style: {
      fill: "rgb(255, 255, 255)",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "80.9262px 309.765px"
    },
    id: "elq7019trixi",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 450.66,
    y1: 421,
    x2: 464,
    y2: 421,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "457.33px 421px"
    },
    id: "elwb1l6v5uign",
    className: "animable"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 22.18,
    y1: 421,
    x2: 440.39,
    y2: 421,
    style: {
      fill: "none",
      stroke: "rgb(38, 50, 56)",
      strokeLinecap: "round",
      strokeMiterlimit: 10,
      transformOrigin: "231.285px 421px"
    },
    id: "elj3nzjt5iulj",
    className: "animable"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "active",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#32DFEC",
    floodOpacity: 1,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))), /*#__PURE__*/React.createElement("filter", {
    id: "hover",
    height: "200%"
  }, /*#__PURE__*/React.createElement("feMorphology", {
    in: "SourceAlpha",
    result: "DILATED",
    operator: "dilate",
    radius: 2
  }), /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#ff0000",
    floodOpacity: 0.5,
    result: "PINK"
  }), /*#__PURE__*/React.createElement("feComposite", {
    in: "PINK",
    in2: "DILATED",
    operator: "in",
    result: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "OUTLINE"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  })), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0   0   0   0   0                0   1   0   0   0                0   0   0   0   0                0   0   0   1   0 "
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLandDelivery);
export default __webpack_public_path__ + "static/media/LandDelivery.24ffa4fdf317ad1d5a2c71bc79e9e23a.svg";
export { ForwardRef as ReactComponent };